import { Ref } from "vue";

export const getDisplayTextByRows = (
  rows: number,
  element: Ref<HTMLElement | null>,
  mockElementId: string,
  text: string
): { text: string; container: HTMLDivElement } | null => {
  const pxToNum = (value: string | null) => {
    if (!value) return 0;
    const match = value.match(/^\d*(\.\d*)?/);
    return match ? Number(match[0]) : 0;
  };
  const cloneContainer = () => {
    if (!element.value) return;
    const container = document.getElementById(mockElementId);
    if (!container) {
      const originStyle = window.getComputedStyle(element.value);
      const container = document.createElement("div");
      const styleNames: string[] = Array.prototype.slice.apply(originStyle);
      styleNames.forEach((name) => {
        container!.style.setProperty(name, originStyle.getPropertyValue(name));
      });

      container.style.position = "fixed";
      container.style.zIndex = "-9999";
      container.style.top = "-9999px";
      container.style.height = "auto";
      container.style.minHeight = "auto";
      container.style.maxHeight = "auto";
      container.id = mockElementId;
      container.innerText = text;
      document.body.appendChild(container);
      return container;
    } else {
      container.innerText = text;
      return container;
    }
  };

  const calcEllipsisText = (container: HTMLElement, maxHeight: number) => {
    const end = text.length;
    const content = text;

    const calcEllipse = () => {
      // calculate the former or later content
      const tail = (left: number, right: number): string => {
        if (right - left <= 1) {
          return content.slice(0, left);
        }

        const middle = Math.round((left + right) / 2);

        // Set the interception location
        container.innerText = content.slice(0, middle);

        // The height after interception still does not match the required height
        if (container.offsetHeight > maxHeight) {
          return tail(left, middle);
        }
        return tail(middle, right);
      };

      container.innerText = tail(0, end);
      return tail(0, end);
    };

    return calcEllipse();
  };

  // Calculate the interceptional text
  const container = cloneContainer();
  if (!container) return null;
  const { paddingBottom, paddingTop, lineHeight } = container.style;
  const maxHeight = Math.ceil(
    (Number(rows) + 0.5) * pxToNum(lineHeight) +
      pxToNum(paddingTop) +
      pxToNum(paddingBottom)
  );

  const res: { container: HTMLDivElement; text: string } = { container };
  if (maxHeight < container.offsetHeight) {
    res.text = calcEllipsisText(container, maxHeight);
  } else {
    res.text = text;
  }
  return res;
};
